
<template>
    <div>

        <button class="btn" :class="btnClass" @click="openModal('make-a-payment-modal-' + _uid)">
            <span v-if="isFree"><i class="far fa-check-circle"></i> Complete Registration</span>
            <span v-else><i class="far fa-money-bill-alt"></i> Make Payment</span>
        </button>

        <modal :id="`make-a-payment-modal-${_uid}`" @trigger="createElements">
            <template slot="title">
                <span v-if="isFree">Confirm your registration</span>
                <span v-else>Make a Payment</span>
            </template>
            <template slot="body" class="p-0">
                <div v-if="isFree">
                    This action required your confirmation.
                </div>
                <div class="payment-form" v-else>
                    <div :id="'card-element-' + _uid" class="card-element"></div>
                    <div :id="'card-errors-' + _uid" class="card-errors" role="alert"></div>
                </div>
            </template>
            <template slot="footer">
                <submit-button v-if="isFree" icon="fa-handshake" :form="form" @click="checkout(null)" processing-text="Processing...">Confirm</submit-button>
                <submit-button v-else :disabled="!canSubmit" icon="fa-handshake" :form="form" @click="submit()" processing-text="Processing...">Submit Payment</submit-button>
            </template>
        </modal>

    </div>
</template>
<script>
    export default {

        props: {
            url: {
                type: String,
                required: true,
            },
            payload: {
                type: Object,
                required: false,
                default: () => ({
                    stripeToken: '',
                })
            },
            redirect: {
                type: String,
                required: false,
                default: '',
            },
            btnClass: {
                type: String,
                required: false,
                default: 'btn-warning btn-sm mr-1'
            },
            isFree: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data() {
            return {
                canSubmit: false,
                stripe: null,
                elements: null,
                card: null,
                form: new Form(this.payload),
            }
        },

        created() {
            this.stripe = Stripe(App.config.stripeKey);
            this.form = new Form({...this.payload, ...{stripeToken: ''}}).dontClear()
        },

        methods: {

            submit() {
                this.form.isSubmitted = true;
                this.stripe.createToken(this.card).then(result => {
                    if (result.error) {
                        var errorElement = document.getElementById('card-errors-' + this._uid);
                        errorElement.textContent = result.error.message;
                        this.form.isSubmitted = false;
                    } else {
                        this.checkout(result.token.id);
                        this.card.clear()
                    }
                });
            },

            checkout(token) {
                this.form.stripeToken = token;
                this.form.post(this.url).then(response => {
                    Alert.withAction('Thank you for signing up for this class.<br>A confirmation email has been sent to you.').then(() => {
                        this.$emit('success');
                        if (this.redirect) {
                            this.redirectTo(this.redirect)
                            return;
                        }
                        this.refreshPage();
                    });
                }).catch(errors => {
                    Alert.error(errors.first())
                    this.$emit('error');
                })
            },

            createElements() {
                if(this.isFree) return;
                this.elements = this.stripe.elements();
                var style = {
                    base: {
                        color: '#32325d',
                        lineHeight: '18px',
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#aab7c4'
                        }
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                };
                this.card = this.elements.create('card', {style});

                this.card.mount('#card-element-' + this._uid);

                this.card.addEventListener('change', event => {
                    var displayError = document.getElementById('card-errors-' + this._uid);
                    if (event.error) {
                        displayError.textContent = event.error.message;
                        this.canSubmit = false;
                    } else {
                        this.canSubmit = true;
                        displayError.textContent = '';
                    }
                });

            }
        },

        watch: {
            payload: {
                handler(value) {
                    this.form = new Form({...this.payload, ...{stripeToken: ''}}).dontClear()
                },
                deep: true,
            }
        }
    }
</script>